<template>
  <section>
    <h1 class="section-head"></h1>
    <div class="columns">
      <div class="column is-8">
        <h4 class="section-mini-head">รายงานยอดขายผลิตภัณฑ์</h4>
        <highcharts :options="chartRevenueOptions" v-if="filteredData.length > 0 || isTableLoading"></highcharts>
        <highcharts :options="chartProductOptions" v-if="filteredData.length > 0 || isTableLoading"></highcharts>

        <h5 class="section-mini-head" v-if="(filteredData.length > 0 || isTableLoading) && false">
          รายการใบสั่งซื้อจากลูกค้า
        </h5>
        <b-table
          :data="filteredData"
          :hoverable="true"
          :loading="isTableLoading"
          :paginated="isPaginated"
          :per-page="perPage"
          :current-page.sync="currentPage"
          :pagination-simple="isPaginationSimple"
          :narrowed="true"
          v-if="(filteredData.length > 0 || isTableLoading) && false"
        >
          <template slot-scope="props">
            <b-table-column field="date" label="วันที่" width="150">
              <strong>
                {{ clean_date(props.row.payment_date) }}
              </strong>
            </b-table-column>

            <b-table-column field="id" label="รหัส" width="150">
              <strong>
                {{ props.row.code }}
              </strong>
            </b-table-column>

            <b-table-column field="name" label="Company">
              {{ props.row.company ? props.row.company : '' }}
            </b-table-column>

            <b-table-column field="total_price" label="ราคารวม (บาท)" width="150">
              {{ props.row.total_price ? parseFloat(props.row.total_price).formatMoney(2) : 0 }}
              บาท
            </b-table-column>
          </template>
          <template slot="footer">
            <th></th>
            <th></th>
            <th>
              <div class="th-wrap is-pulled-right">รวม</div>
            </th>
            <th>
              <div class="th-wrap">{{ parseFloat(this.grandTotal).formatMoney(2) }} บาท</div>
            </th>
          </template>
        </b-table>
        <div class="notification has-text-centered" v-else></div>
      </div>
      <div class="column">
        <h4 class="section-mini-head">Filter Options</h4>

        <b-field label="ชื่อบริษัท">
          <b-autocomplete
            v-model="company"
            placeholder="ชื่อบริษัท"
            :clear-on-select="false"
            :keep-first="true"
            :open-on-focus="true"
            :data="filteredCustomerObj"
            field="name"
            :disabled="customerList.length < 1"
          >
          </b-autocomplete>
        </b-field>

        <b-field label="ชื่อผลิตภัณฑ์">
          <b-autocomplete
            v-model="product_filter"
            :data="filteredProduct"
            placeholder="ชื่อผลิตภัณฑ์"
            :clear-on-select="false"
            :keep-first="true"
            :open-on-focus="true"
            field="name"
          >
          </b-autocomplete>
        </b-field>

        <b-field label="เริ่มต้น">
          <b-datepicker v-model="dateStart" :date-formatter="clean_date" placeholder="กดเพื่อเลือกวันเริ่มต้น.." icon="calendar"> </b-datepicker>
        </b-field>

        <b-field label="จนถึง">
          <b-datepicker v-model="dateEnd" :date-formatter="clean_date" placeholder="กดเพื่อเลือกวัน.." icon="calendar"> </b-datepicker>
        </b-field>
        <p class="section-mini-head"></p>
        <div class="buttons">
          <b-button type="is-info" icon-left="search" @click="getOrder()" expanded>Submit</b-button>
        </div>

        <p class="section-mini-head">ภาพรวม</p>
        <div class="notification">
          <div class="content">
            <h4>
              ยอดขาย
            </h4>
            <h2 class="is-marginless">{{ parseFloat(this.grandTotal).formatMoney(2) }} บาท</h2>
            <p>
              ยอดก่อนลดราคา
              {{ parseFloat(this.grandTotal + this.totalDiscount).formatMoney(2) }}
              บาท
            </p>
          </div>
          <hr />
          <div class="content">
            <h4>
              ส่วนลด
            </h4>
            <h2 class="is-marginless">{{ parseFloat(this.totalDiscount).formatMoney(2) }} บาท</h2>
            <p>
              คิดเป็น
              {{ parseFloat((this.totalDiscount / (this.grandTotal + this.totalDiscount)) * 100).formatMoney(2) }}% ของยอดขาย
            </p>
          </div>
          <hr />
          <div class="content">
            <h4>
              จำนวนบริษัทที่สั่ง
            </h4>
            <h2 class="is-marginless">
              {{ parseFloat(this.chartRevenueOptions.xAxis.categories.length).formatMoney(0) }}
              ราย
            </h2>
          </div>
          <hr />
          <div class="content">
            <h4>
              จำนวนคำสั่งซื้อ
            </h4>
            <h2 class="is-marginless">{{ parseFloat(filteredData.length).formatMoney(0) }} คำสั่ง</h2>
          </div>
          <hr />
          <div class="content">
            <h4>
              ประเภทสินค้า
            </h4>
            <h2 class="is-marginless">
              {{ parseFloat(this.chartProductOptions.xAxis.categories.length).formatMoney(0) }}
              ประเภท
            </h2>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CustomerModel from '@/model/customer_model';
import OrderModel from '@/model/order_model';
import Request from '@/libraries/request';
import Const from '@/const/const';
import moment from 'moment';
import Highcharts from 'highcharts';

import { Chart } from 'highcharts-vue';

export default {
  name: 'Report_order',
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      orders: [],
      product_filter: '',
      customerList: [],
      productList: [],
      company: '',
      dateStart: new Date(),
      dateEnd: new Date(),
      dataList: {},
      isLoading: true,
      isTableLoading: false,

      grandTotal: 0.0,
      chartData: [],

      categoriesData: [],
      seriesData: [],
      totalDiscount: 0.0,

      isPaginated: true,
      isPaginationSimple: false,
      currentPage: 1,
      perPage: 20,
      chartHeight: 400,

      chartRevenueOptions: {
        chart: {
          type: 'bar',
          height: 400,
        },
        title: {
          text: 'รายงานยอดขายผลิตภัณฑ์ (แยกตามบริษัท)',
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          lineHeight: 10,
          type: 'logarithmic',
          title: {
            text: '<b>จำนวน (บาท)</b>',
          },
        },
        tooltip: {
          formatter: function() {
            return this.x + '<br><strong>' + Highcharts.numberFormat(this.y, 2, '.', ',') + ' บาท </strong>';
          },
          headerFormat: '<b>{categories.name}</b><br />',
          //pointFormat: Highcharts.numberFormat(this.y, 0) +' บาท'
        },

        legend: {},
        plotOptions: {
          series: {
            stacking: 'normal',
          },
        },
        series: [
          {
            name: 'รายได้',
            data: [],
            dataLabels: {
              enabled: true,
              color: '#000',
              align: 'left',
              formatter: function() {
                return Highcharts.numberFormat(this.y, 2, '.', ',');
              },
              x: 10, // 10 pixels down from the top
              style: {
                fontSize: '10px',
                fontFamily: 'Verdana, sans-serif',
              },
            },
          },
        ],
      },
      chartProductOptions: {
        chart: {
          type: 'bar',
          height: 400,
        },
        title: {
          text: 'รายงานยอดขายผลิตภัณฑ์ (แยกตามผลิตภัณฑ์)',
        },
        xAxis: {
          categories: [],
          crosshair: true,
        },
        yAxis: {
          lineHeight: 10,
          type: 'logarithmic',
          title: {
            text: '<b>จำนวน (บาท)</b>',
          },
        },
        tooltip: {
          formatter: function() {
            return this.points.reduce(function(s, point) {
              return (
                s +
                '<br/>' +
                point.series.name +
                ': ' +
                Highcharts.numberFormat(point.y, 2, '.', ',') +
                ' ' +
                (point.colorIndex == 1 ? point.series.options.unit[point.point.index] : 'บาท')
              );
            }, '<b>' + this.x + '</b>');
          },
          shared: true,
          //pointFormat: Highcharts.numberFormat(this.y, 0) +' บาท'
        },

        legend: {},
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
            },
          },
        },
        series: [
          {
            name: 'มูลค่าขาย',
            data: [],
            dataLabels: {
              enabled: true,
              color: '#000',
              align: 'left',
              formatter: function() {
                return Highcharts.numberFormat(this.y, 2, '.', ',');
              },
              x: 10, // 10 pixels down from the top
              style: {
                fontSize: '10px',
                fontFamily: 'Verdana, sans-serif',
              },
            },
          },
          {
            name: 'จำนวน',
            data: [],
            dataLabels: {
              enabled: true,
              color: '#000',
              align: 'left',
              formatter: function() {
                return Highcharts.numberFormat(this.y, 2, '.', ',');
              },
              x: 10, // 10 pixels down from the top
              style: {
                fontSize: '10px',
                fontFamily: 'Verdana, sans-serif',
              },
            },
          },
          {
            name: 'ส่วนลด',
            data: [],
            dataLabels: {
              enabled: true,
              color: '#000',
              align: 'left',
              formatter: function() {
                return Highcharts.numberFormat(this.y, 2, '.', ',');
              },
              x: 10, // 10 pixels down from the top
              style: {
                fontSize: '10px',
                fontFamily: 'Verdana, sans-serif',
              },
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.isLoading = true;
    this.init();
  },
  computed: {
    filteredCustomerObj() {
      return this.customerList.filter(option => {
        if (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.company.toLowerCase()) >= 0
        ) {
          return option;
        } else {
          return false;
        }
      });
    },
    filteredProduct() {
      return this.productList.filter(option => {
        if (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.product_filter.toLowerCase()) >= 0
        ) {
          return option;
        } else {
          return false;
        }
      });
    },
    filteredData: function() {
      this.grandTotal = 0;
      this.chartData = [];
      return this.orders.filter(order => {
        if (
          (order.company && order.company.toLowerCase().includes(this.company.toLowerCase())) ||
          (order.cus_name && order.cus_name.toLowerCase().includes(this.company.toLowerCase()))
        ) {
          this.recalculateData(order);
          return true;
        } else {
          return false;
        }
      });
    },
  },
  methods: {
    async init() {
      this.isLoading = true;
      this.customerList = await CustomerModel.get_all_customer();
      Request.get('product', res => {
        // this.loadingComponent.close();
        this.isLoading = false;
        if (res.data.status) {
          this.productList = res.data.data;
        }
      });
    },
    async getOrder() {
      this.isTableLoading = true;
      this.orders = await OrderModel.get_order_by_date_range(moment(this.dateStart).format('YYYY-MM-DD 00:00:00'), moment(this.dateEnd).format('YYYY-MM-DD 23:59:59'));
      this.isTableLoading = false;
    },
    recalculateData(data) {
      this.chartData.push(data);
      let self = this;
      //Manipulate Data for chart display

      let groupedData = this.groupBy(this.chartData, 'cus_id');
      let reArrangedRevenueDatas = [];
      let productDatas = [];
      //console.log(typeof groupedData);
      //console.log(groupedData);

      groupedData.forEach(function(groupedDatas, index) {
        reArrangedRevenueDatas[index] = {
          name: '',
          total: 0.0,
        };
        groupedDatas.forEach((groupedData, dataIndex) => {
          reArrangedRevenueDatas[index].name = groupedData.company;

          //Product
          groupedData.items.forEach((itemData, itemIndex) => {
            //console.log(self);
            if (self.product_filter) {
              if (itemData.name && itemData.name.toLowerCase().includes(self.product_filter.toLowerCase())) {
                productDatas.push(itemData);
                reArrangedRevenueDatas[index].total = parseFloat(reArrangedRevenueDatas[index].total) + parseFloat(itemData.total_price);
              }
            } else {
              productDatas.push(itemData);
              reArrangedRevenueDatas[index].total = parseFloat(reArrangedRevenueDatas[index].total) + parseFloat(itemData.total_price);
            }
          });
        });
      });

      let groupedProductData = this.groupBy(productDatas, 'pro_id');
      //console.log(groupedProductData);
      let reArrangedProductDatas = [];
      groupedProductData.forEach((productData, productIndex) => {
        reArrangedProductDatas[productIndex] = {
          id: 0,
          name: '',
          unit: '',
          total_discount: 0.0,
          total_price: 0.0,
          total_amount: 0.0,
        };
        productData.forEach((item, index) => {
          reArrangedProductDatas[productIndex].id = item.pro_id;
          reArrangedProductDatas[productIndex].name = item.name;
          reArrangedProductDatas[productIndex].unit = Const.product_unit[item.unit];
          reArrangedProductDatas[productIndex].total_discount +=
            parseFloat(item.price * item.amount) - parseFloat(item.total_price) ? parseFloat(item.price * item.amount) - parseFloat(item.total_price) : 0;
          reArrangedProductDatas[productIndex].total_amount += parseFloat(item.amount) ? parseFloat(item.amount) : 0;
          reArrangedProductDatas[productIndex].total_price += parseFloat(item.total_price) ? parseFloat(item.total_price) : 0;
        });
      });

      //console.log(reArrangedProductDatas);
      reArrangedProductDatas.sort((a, b) => b.total_price - a.total_price);
      let categoriesProductData = [];
      let seriesProductUnitData = [];
      let seriesPriceProductData = [];
      let seriesAmountProductData = [];
      let seriesDiscountProductData = [];
      this.totalDiscount = 0.0;
      reArrangedProductDatas.forEach((reArrangedProductData, reArrangedProductDataIndex) => {
        categoriesProductData.push(reArrangedProductData.name);
        seriesProductUnitData.push(reArrangedProductData.unit);
        seriesPriceProductData.push(reArrangedProductData.total_price);
        seriesAmountProductData.push(reArrangedProductData.total_amount);
        seriesDiscountProductData.push(reArrangedProductData.total_discount);
        this.totalDiscount += reArrangedProductData.total_discount;
      });

      this.chartProductOptions.xAxis.categories = categoriesProductData;
      this.chartProductOptions.series[0].data = seriesPriceProductData;
      this.chartProductOptions.series[1].data = seriesAmountProductData;
      this.chartProductOptions.series[1].unit = seriesProductUnitData;
      this.chartProductOptions.series[2].data = seriesDiscountProductData;

      this.chartProductOptions.chart.height = categoriesProductData.length * 50 < 500 ? 500 : categoriesProductData.length * 50;

      reArrangedRevenueDatas.sort((a, b) => b.total - a.total);

      let categoriesData = [];
      let seriesData = [];
      let grandTotal = 0.0;
      reArrangedRevenueDatas.forEach((reArrangedData, reArrangedDataIndex) => {
        if (reArrangedData.total > 0) {
          categoriesData.push(reArrangedData.name);
          seriesData.push(reArrangedData.total);
          grandTotal = parseFloat(grandTotal) + parseFloat(reArrangedData.total);
        }
      });

      this.grandTotal = grandTotal;
      this.chartRevenueOptions.xAxis.categories = categoriesData;
      this.chartRevenueOptions.series[0].data = seriesData;

      this.chartRevenueOptions.chart.height = categoriesData.length * 30 < 400 ? 400 : categoriesData.length * 30;
      //console.log(reArrangedData);
      //console.log(this.chartRevenueOptions.xAxis.categories);
      //console.log(this.chartRevenueOptions.series[0].data);
    },
    groupBy(xs, key) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, []);
    },
    clean_date(date) {
      return moment(date).format('YYYY-MM-DD');
    },
  },
};
</script>

<style>
.highchart-box {
  height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Report/order.vue